import { map } from "leaflet";

// Google Maps Configuration
export const GOOGLE_MAPS_CONFIG = {
  // Get your API key from: https://console.cloud.google.com/apis/credentials
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',

  mapId: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || '',

  // Default map configuration
  defaultCenter: {
    lat: 40.7128, // New York City
    lng: -74.0060
  },

  defaultZoom: 13,

  // Map styling options
  // Prefer disableDefaultUI so zoom / Street View / camera chrome stay hidden
  // even when a cloud mapId is set (those controls sit bottom-right by default).
  mapOptions: {
    disableDefaultUI: true,
    zoomControl: false,
    streetViewControl: false,
    fullscreenControl: true,
    mapTypeControl: false,
    rotateControl: false,
    cameraControl: false,
    scaleControl: false,
    // gestureHandling: 'cooperative' as 'cooperative',
    gestureHandling: 'greedy' as 'greedy',
    // Note: `styles` is ignored when `mapId` is set (cloud map styling).
    styles: [
      // Custom map styling for better business visibility
      {
        featureType: 'poi.business',
        stylers: [{ visibility: 'off' }] // Hide default business markers
      },
      {
        featureType: 'poi.medical',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'poi.school',
        stylers: [{ visibility: 'off' }]
      }
    ]
  },

  // Marker styling
  markerOptions: {
    primary: {
      fillColor: '#2563eb', // primary-600
      fillOpacity: 1,
      strokeColor: '#ffffff',
      strokeWeight: 2,
      scale: 1.2
    },
    highlighted: {
      fillColor: '#dc2626', // red-600
      fillOpacity: 1,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 1.5
    }
  }
};

// Validation function to check if API key is configured
export const isGoogleMapsConfigured = (): boolean => {
  return Boolean(GOOGLE_MAPS_CONFIG.apiKey && GOOGLE_MAPS_CONFIG.apiKey.length > 10);
};

// Error messages for configuration issues
export const GOOGLE_MAPS_ERRORS = {
  NO_API_KEY: 'Google Maps API key is not configured. Please add REACT_APP_GOOGLE_MAPS_API_KEY to your .env file.',
  INVALID_API_KEY: 'Invalid Google Maps API key. Please check your configuration.',
  LOAD_FAILED: 'Failed to load Google Maps. Please check your internet connection and API key.',
  API_TARGET_BLOCKED: 'ApiTargetBlockedMapError: Your API key has domain restrictions that block localhost. Please update your API key restrictions in Google Cloud Console.',
  QUOTA_EXCEEDED: 'Google Maps API quota exceeded. Please check your usage limits in Google Cloud Console.',
  BILLING_NOT_ENABLED: 'Google Maps API billing is not enabled. Please enable billing in Google Cloud Console.'
};
